import { WIDGET_HOME_TYPE_V2, WIDGET_TYPE_V2 } from '../common';
import { ValueOf } from '../../common/utils';
import { DateRageType } from '../../common/date';
import { Attachment } from '../../../components/input/ImageAndVideoUploadV2/types';
import { CouponItemV2 } from '../../coupons';
import {
  TimeDealWidgetsFindOneResponseWidgetDto,
  TimeDealWidgetsUpdateRequestWidgetDto,
  TimeDealWidgetsUpdateRequestWidgetDtoLayoutTypeEnum,
  TimeDealWidgetsUpdateRequestWidgetItemTimeDealDto,
  WidgetResponseWidgetItemTimeDealDto,
} from '../../api/widgets';

export const TIMEDEAL_WIDGET_LAYOUT_TYPE_V2 = {
  SWIPE_1XN: 'swipe1xN',
} as const;

export type TIMEDEAL_WIDGET_LAYOUT_TYPE_V2 = ValueOf<typeof TIMEDEAL_WIDGET_LAYOUT_TYPE_V2>;

export const TIMEDEAL_WIDGET_LINK_TYPE_V2 = {
  PRODUCT: 'product',
} as const;

export type TIMEDEAL_WIDGET_LINK_TYPE_V2 = ValueOf<typeof TIMEDEAL_WIDGET_LINK_TYPE_V2>;

export const TIMEDEAL_WIDGET_ATTACHMENT_TYPE_V2 = {
  MOBILE: 'mobile',
  PC: 'pc',
} as const;
type TIMEDEAL_WIDGET_ATTACHMENT_TYPE_V2 = ValueOf<typeof TIMEDEAL_WIDGET_ATTACHMENT_TYPE_V2>;

export type TimedealWidgetLinkItem = {
  id?: number;
  name: string;
};

export type TimedealWidgetItem = {
  id: number;
  coupon: CouponItemV2 | null;
  mobileImage: Required<Attachment>[];
  pcImage: Required<Attachment>[];
  memo: string;
  linkType: TIMEDEAL_WIDGET_LINK_TYPE_V2;
  link: TimedealWidgetLinkItem;
};

export class TimedealWidgetDetailV2 {
  type: typeof WIDGET_TYPE_V2.TIMEDEAL;
  layoutType: TIMEDEAL_WIDGET_LAYOUT_TYPE_V2;
  mainTitle: string;
  subTitle?: string;
  memo?: string;
  exposurePeriod: DateRageType;
  currentExposurePage?: string;
  isUseCoupon: boolean;
  widgetItemTimeDealList: TimedealWidgetItem[];

  private getImage(item: WidgetResponseWidgetItemTimeDealDto, type: TIMEDEAL_WIDGET_ATTACHMENT_TYPE_V2) {
    return [item.widgetItemTimeDealAttachments.find((attachment) => attachment.type === type)!];
  }

  constructor(detail: TimeDealWidgetsFindOneResponseWidgetDto) {
    this.type = WIDGET_TYPE_V2.TIMEDEAL;
    this.layoutType = detail.layoutType;
    this.mainTitle = detail.mainTitle;
    this.subTitle = detail.subTitle;
    this.memo = detail.memo;
    this.exposurePeriod = {
      startDate: detail.exposureStartDate,
      endDate: detail.exposureEndDate,
    };
    this.currentExposurePage = detail.home?.type === WIDGET_HOME_TYPE_V2.MAIN ? '메인 페이지' : detail.home?.title;
    this.isUseCoupon = detail.isUseCoupon;
    this.widgetItemTimeDealList = detail.widgetItemTimeDeals.map((item) => ({
      id: item.id,
      coupon: item.coupon && detail.isUseCoupon ? new CouponItemV2(item.coupon) : null,
      mobileImage: this.getImage(item, TIMEDEAL_WIDGET_ATTACHMENT_TYPE_V2.MOBILE),
      pcImage: this.getImage(item, TIMEDEAL_WIDGET_ATTACHMENT_TYPE_V2.PC),
      memo: item.memo,
      linkType: item.linkType,
      link: {
        id: item.linkId,
        name: item.linkName,
      },
    }));
  }
}

export class TimedealWidgetRequestPayloadV2 implements TimeDealWidgetsUpdateRequestWidgetDto {
  mainTitle: string;
  subTitle: string;
  memo: string;
  exposureStartDate: string | null;
  exposureEndDate: string | null;
  isUseCoupon: boolean;
  layoutType: TimeDealWidgetsUpdateRequestWidgetDtoLayoutTypeEnum;
  widgetItemTimeDeals: Array<TimeDealWidgetsUpdateRequestWidgetItemTimeDealDto>;
  constructor(detail: TimedealWidgetDetailV2) {
    this.mainTitle = detail.mainTitle;
    this.subTitle = detail.subTitle || '';
    this.memo = detail.memo || '';
    this.exposureStartDate = detail.exposurePeriod.startDate && new Date(detail.exposurePeriod.startDate).toISOString();
    this.exposureEndDate = detail.exposurePeriod.endDate && new Date(detail.exposurePeriod.endDate).toISOString();
    this.isUseCoupon = detail.isUseCoupon || false;
    this.layoutType = detail.layoutType;
    this.widgetItemTimeDeals = detail.widgetItemTimeDealList.map((item) => ({
      id: item.id,
      couponId: item.coupon?.id,
      linkId: item.link.id,
      linkType: item.linkType,
      memo: item.memo,
      widgetItemTimeDealAttachments: [
        { ...item.mobileImage[0], type: TIMEDEAL_WIDGET_ATTACHMENT_TYPE_V2.MOBILE },
        { ...item.pcImage[0], type: TIMEDEAL_WIDGET_ATTACHMENT_TYPE_V2.PC },
      ],
    }));
  }
}
